import { MutationTree } from 'vuex';
import { IDealroomViewState } from './dealroom-view.store';
import { IDocument } from '@/types/Document';
import { IField } from '@/fields/types/field';
import { IDocumentPage } from '@/types/document-page';

export const mutationSetLoading = 'setLoading';
export const mutationSetLoaded = 'setLoaded';
export const mutationSetDocument = 'setDocument';

export const mutationSetFields = 'setFields';
export const mutationSetPageWidth = 'setPageWidth';
export const mutationSetDocumentPages = 'setDocumentPages';

export const mutations: MutationTree<IDealroomViewState> = {
  [mutationSetLoading](state: IDealroomViewState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetLoaded](state: IDealroomViewState, loaded: boolean) {
    state.loaded = loaded;
  },
  [mutationSetDocument](state: IDealroomViewState, document: IDocument) {
    state.document = { ...document };
  },
  [mutationSetFields](state: IDealroomViewState, fields: IField[]) {
    state.fields = fields;
  },
  [mutationSetPageWidth](state: IDealroomViewState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [mutationSetDocumentPages](state: IDealroomViewState, pages: IDocumentPage[]) {
    state.document.pages = pages;
  },
};
